import { Component, effect, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { L10nTranslationModule } from 'angular-l10n';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-collapse-all',
  templateUrl: './collapse-all.component.html',
  styleUrl: './collapse-all.component.scss',
  imports: [L10nTranslationModule, NgClass, MatIcon],
})
export class CollapseAllComponent {
  collapseLabel = input<string>();
  expandLabel = input<string>();
  disabled = input(false);
  isCollapsed = input<boolean>();
  onToggle = output<void>()
  private readonly iconNameMap = {
    expand: 'expand-icon',
    collapse: 'collapse-icon',
  };
  public iconName = signal(this.iconNameMap.expand);
  public iconLabel = signal('');
  constructor() {
    effect(() => {
      const val = this.isCollapsed();
      if (val != null) {
        this.setIconAndLabel(val);
      }
    });
  }
  private setIconAndLabel(isCollapsed: boolean) {
    this.iconName.set(isCollapsed ? this.iconNameMap.expand : this.iconNameMap.collapse);
    this.iconLabel.set(isCollapsed ? this.expandLabel() : this.collapseLabel());
  }
  public toggle() {
    this.onToggle.emit();
  }
}
